import React, { createContext, useState, useEffect } from "react";
import { fetchcategory } from "../ApiService/Category/Category";
import { fetchsubcategory } from "../ApiService/SubCategory/SubCategory";
import { fetchBrands } from "../ApiService/Brand/Brand";
import { fetchproduct } from "../ApiService/product/product";


export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [brand, setBrands] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [Product, setProducts] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [categories, subcategories, brand, Product, similarProducts] = await Promise.all([
          fetchcategory(),
          fetchsubcategory(),
          fetchBrands(),
          fetchproduct(),


        ]);
        setCategories(categories || []);
        setSubcategories(subcategories || []);
        setBrands(brand || []);
        setProducts(Product || []);

      } catch (err) {
        console.error("Error loading data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);
  return (
    <CategoryContext.Provider
      value={{
        categories,
        subcategories,
        brand,
        Product,

        loading,
        error,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};
